import { render, staticRenderFns } from "./BrandLcs.vue?vue&type=template&id=6adc3db1&scoped=true&"
import script from "./BrandLcs.vue?vue&type=script&lang=js&"
export * from "./BrandLcs.vue?vue&type=script&lang=js&"
import style0 from "./BrandLcs.vue?vue&type=style&index=0&id=6adc3db1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc3db1",
  null
  
)

export default component.exports